import type { SnackBarState } from '..';
import type { DisplayStrategyCallback } from '.';

export function create(
  state: SnackBarState,
  setState: (s: Pick<SnackBarState, keyof SnackBarState>) => void
): DisplayStrategyCallback {
  return () => {
    return new Promise((resolve) => {
      const ssBtn = document.getElementById('saved-search-button');

      if (ssBtn == null) {
        setState({
          savedSearchButtonOutsideViewport: true,
        } as SnackBarState);
        resolve(true);
      } else {
        const rect = ssBtn.getBoundingClientRect();
        if (!state.savedSearchButtonOutsideViewport) {
          //saved search button is not in viewport
          const savedSearchButtonOutsideViewport = !(
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom - ssBtn.offsetHeight <=
              (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
              (window.innerWidth || document.documentElement.clientWidth)
          );

          setState({
            savedSearchButtonOutsideViewport,
          } as SnackBarState);
          resolve(savedSearchButtonOutsideViewport);
          return;
        }
        resolve(true);
      }
    });
  };
}
